<script lang="ts">
import { computed, defineComponent, provide, h, unref } from 'vue';

import {
  makeAppearanceProps,
  makeDisabledProps,
  makeGroupProps,
  makeReadonlyProps,
  makeTagProps,
  makeThemeProps,
  provideTheme,
  useAppearance,
  useGroup,
  useRender
} from '../../composable';
import { classNames } from '../../utils';

import { makeExpandablePanelsProps } from './composable/expandablePanels';

import type { InjectionKey } from 'vue';
import type { IGroupItemProvide } from '../../composable';

type IExpandablePanelsProvide = {
  readOnly: boolean;
};

export const CdsExpandablePanelsGroupSymbol: InjectionKey<IGroupItemProvide> =
  Symbol.for('cds:expandable-panels-group');
export const CdsExpandablePanelSymbol: InjectionKey<IExpandablePanelsProvide> = Symbol.for('cds:expandable-panel');

export const componentName = 'CdsExpandablePanels';
export default defineComponent({
  name: componentName,
  props: {
    ...makeExpandablePanelsProps(),
    ...makeAppearanceProps(),
    ...makeDisabledProps(),
    ...makeReadonlyProps(),
    ...makeGroupProps(),
    ...makeTagProps(),
    ...makeThemeProps()
  },
  emits: {
    'update:modelValue': (value: any) => true
  },
  setup(props, { slots }) {
    const { themeClasses } = provideTheme(props);
    const variantClass = computed(() => props.variant && `cds-expandable-panels--variant-${props.variant}`);
    const { appearanceClasses } = useAppearance(props, componentName);

    useGroup(props, CdsExpandablePanelsGroupSymbol);

    provide(CdsExpandablePanelSymbol, {
      readOnly: props.readonly
    });

    useRender(() =>
      h(
        props.tag,
        {
          class: classNames('cds-expandable-panels', unref(variantClass), unref(appearanceClasses), unref(themeClasses))
        },
        [slots.default?.()]
      )
    );

    return {};
  }
});
</script>
